export default __webpack_public_path__ + "static/media/mobile-integration1.b89b3504.png";